/* import __COLOCATED_TEMPLATE__ from './pricing-article-link.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();